// Revision numbering shared by Transfer Orders and Sales Orders — mirrors
// backend/order_revisions.py: X → X/1 → X/1a → X/1b → … → X/1z → X/1aa …
const letters = (k) => {
  let out = "";
  while (k > 0) {
    const r = (k - 1) % 26;
    out = String.fromCharCode(97 + r) + out;
    k = Math.floor((k - 1) / 26);
  }
  return out;
};

export const revisionSuffix = (n) => {
  const v = Number(n || 0);
  if (v <= 0) return "";
  return `/1${letters(v - 1)}`;
};

export const revisionNo = (base, n) => `${base || "—"}${revisionSuffix(n)}`;
